import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getInsuranceDetailsUrl } from "../utils/urlHelper";

const insuranceDetailsApi = createApi({
  reducerPath: "insuranceDetails",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_AUTH_URL}`,
    prepareHeaders: async (headers) => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json; version=3.0");
      headers.set("Source", "LPLWEB");
      return headers;
    },
  }),
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    createInsuranceDetails: builder.mutation({
      query: (body) => ({
        url: getInsuranceDetailsUrl("create_insurance_detail"),
        method: "POST",
        body,
      }),
    }),
    updateLoan: builder.mutation({
      query: (body) => ({
        url: getInsuranceDetailsUrl("update-loan"),
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateInsuranceDetailsMutation,
  useUpdateLoanMutation,
} = insuranceDetailsApi;

export { insuranceDetailsApi };
